<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Vehicles">
      <button class="btn btn-secondary" @click="syncVehicles" v-submitting="submitting">
        Sync Vehicles
      </button>
      
      <div slot="subheader" class="mt-4 sm:mt-0">
        <NavTabs 
          :tabs="[
            { name: 'Vehicles', route: { name: 'VehicleList' } },
            { name: 'Vehicle Groups', route: { name: 'VehicleGroups' } },
          ]" 
        />
      </div>
    </PageHeader>

    <div class="container">
      <Loading v-if="loading" />

      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="vehicles.meta.total < 1" class="py-12 text-center">
          <p class="mb-8 text-lg font-bold">
            No vehicles have been sync'd from WEBFLEET yet.
          </p> 
          <button class="btn btn-secondary" @click="syncVehicles" v-submitting="submitting">
            Sync Vehicles from WEBFLEET
          </button>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table :items="vehicles.data" 
            :keys="[
              { name: 'Name', slug: 'objectname', class: 'font-bold' },
              { name: 'Number', slug: 'objectno' },
              { name: 'License Plate', slug: 'licenseplatenumber' },
              { name: 'Odometer', slug: 'odometer_current', display: (val) => val + ' km' },
              { name: 'Speed Limit', slug: 'speedlimit', display: (val) => val + 'km/h' },
            ]" />
          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="vehicles.meta.total" :per-page="vehicles.meta.per_page" :current-page="vehicles.meta.current_page" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VehicleList',

  metaInfo: {
    title: 'Vehicles'
  },

  async created () {
    await this.getVehicles()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      vehicles: {},
      loading: true,
      submitting: false
    }
  },

  methods: {
    async getVehicles () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/vehicles`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.vehicles = data.vehicles
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },
    
    async syncVehicles () {
      try {
        this.submitting = true
        await this.$api.get(`account/${this.$route.params.account}/sync/vehicles`)
        this.getVehicles()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getVehicles()
      },
      deep: true
    }
  }
}
</script>